import {baseApiInstance} from "./baseApiInstance";

const getApiRequest = async (url) => {
    return await baseApiInstance
        .get(url)
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });
};

export default getApiRequest;
